var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 201,
    viewBox: "0 0 66 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64784 67.096V194.932C5.64784 197.288 7.56754 199.208 9.92356 199.208H56.5204C58.8764 199.208 60.7962 197.288 60.7962 194.932V67.096C60.7962 64.74 58.8764 62.8203 56.5204 62.8203H9.92356C7.56754 62.8203 5.64784 64.74 5.64784 67.096ZM56.7823 7.75916C51.983 4.00698 44.1295 2 33.222 2C22.3145 2 14.4611 4.00698 9.66179 7.75916C4.86249 11.5113 2.41919 17.8813 2.41919 26.6073C2.41919 35.3334 4.77523 41.3543 9.66179 45.1937C14.5484 49.0332 22.3145 50.9529 33.222 50.9529C44.1295 50.9529 52.0702 49.0332 56.7823 45.1937C61.4943 41.3543 63.9376 35.1588 63.9376 26.6073C63.9376 18.0559 61.5816 11.6859 56.7823 7.75916Z",
    fill: "#191818",
    stroke: "#F57423",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.0e2e34ce1a88935a91af1667289e1725.svg";
export { ForwardRef as ReactComponent };